
<div class="h-screen">
    <router-outlet />

</div>
